<template>
    <form id="mainForm" action="#" method="post">
        <Card>
            <template #title>
                <Toolbar>
                    <template #left>
                        <div class="p-card-title">
                            [{{mode}}] {{$t('order')}}
                        </div>
                        <div style="margin-left: 10px" v-if="mode != this.$FORM_MODE_CREATE">
                            <Button type="button" icon="pi pi-info" @click="toggle" aria:haspopup="true" aria-controls="overlay_panel" class="p-button-rounded p-button-outlined p-button-sm" />

                            <OverlayPanel ref="op" appendTo="body" :showCloseIcon="true" id="overlay_panel" style="width: 550px" :breakpoints="{'960px': '80vw'}">
                                <div class="grid field">
                                    <div class="row">
                                        <i class="pi pi-plus-circle" /> {{this.$formatDateTime(header.Created_Date)}}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{header.Created_By}}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Edited_Date">
                                    <div class="row">
                                        <i class="pi pi-pencil" /> {{this.$formatDateTime(header.Edited_Date)}}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{header.Edited_By}}
                                    </div>
                                </div>
                            </OverlayPanel>
                        </div>
                    </template>

                    <template #right>
                        <Button icon="pi pi-chevron-left" label="Back" class="p-button mr-2" @click="backToIndex" />
                        <!-- <Button icon="pi pi-save" label="Save" class="p-button-success" @click="confirm($event)" /> -->
                        <ConfirmPopup></ConfirmPopup>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <TabView :activeIndex="activeIndex">
                    <TabPanel v-if="oldStyle" header=" Header & Detail">
                        <div class="p-inputtext-sm p-fluid">
                            <div class="grid">
                                <ViewOrder :header="header" :oldStyle="oldStyle" :mode="mode" :orderNo="header.Order_No" :orderType="orderType"/>
                            </div>

                            <div class="grid">
                                <div class="col-12">
                                    <DataTable v-if="header" :loading="!header.Details" :value="header.Details ? header.Details : null" responsiveLayout="scroll" class="p-datatable-sm editable-cells-table">
                                        <Column field="Item_No" :header="$t('item_no')" key="Item_No" style="width:10%">  
                                        </Column>
                                        <Column field="sap_no" :header="$t('sap_no')" key="Item_No" style="width:10%" v-if="!oldStyle">  
                                        </Column>
                                        <Column field="SAP_Item_No" :header="$t('sap_item_no')" key="Item_No" style="width:10%">  
                                        </Column>
                                        <Column field="Material_Name" :header="$t('material_name')" key="material_name">
                                        </Column>
                                        <Column field="Qty" :header="$t('qty')" key="Qty" style="width:15%">
                                        </Column>
                                        <Column field="UOM" :header="$t('uom')" key="UOM" style="width:10%">
                                        </Column>
                                        <Column field="PO_SO_No" :header="$t('po_so_no')" key="PO_SO_No" style="width:15%">
                                        </Column>
                                        <Column field="LN_SO_Item_No" :header="$t('ln_so_item_no')" key="LN_SO_Item_No" style="width:15%">
                                        </Column>
                                        <Column field="LN_STO_Item_No" :header="$t('ln_sto_item_no')" key="LN_STO_Item_No" style="width:15%">
                                        </Column>
                                    </DataTable>
                                </div>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel v-else-if="!oldStyle" v-for="sapOrder in sapOrders" v-bind:key="sapOrder" :header="sapOrder.Document_No">
                        <div class="p-inputtext-sm p-fluid">
                            <div class="grid">
                            <ViewOrder :header="sapOrder" :oldStyle="oldStyle" :mode="mode" :orderNo="header.Order_No" :orderType="orderType"/>
                        </div>

                        <div class="grid">
                                <div class="col-12">
                                    <DataTable v-if="header" :loading="!header.Details" :value="header.Details ? header.Details : null" responsiveLayout="scroll" class="p-datatable-sm editable-cells-table">
                                        <Column field="Item_No" :header="$t('item_no')" key="Item_No" style="width:10%">  
                                        </Column>
                                        <Column field="sap_no" :header="$t('sap_no')" key="Item_No" style="width:10%" v-if="!oldStyle">  
                                        </Column>
                                        <Column field="SAP_Item_No" :header="$t('sap_item_no')" key="Item_No" style="width:10%">  
                                        </Column>
                                        <Column field="Material_Name" :header="$t('material_name')" key="material_name">
                                        </Column>
                                        <Column field="Qty" :header="$t('qty')" key="Qty" style="width:15%">
                                        </Column>
                                        <Column field="UOM" :header="$t('uom')" key="UOM" style="width:10%">
                                        </Column>
                                        <Column field="PO_SO_No" :header="$t('po_so_no')" key="PO_SO_No" style="width:15%">
                                        </Column>
                                        <Column field="LN_SO_Item_No" :header="$t('ln_so_item_no')" key="LN_SO_Item_No" style="width:15%">
                                        </Column>
                                        <Column field="LN_STO_Item_No" :header="$t('ln_sto_item_no')" key="LN_STO_Item_No" style="width:15%">
                                        </Column>
                                    </DataTable>
                                </div>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel header="Transporter">
                        <div class="p-inputtext-sm p-fluid">
                            <div class="grid">
                                <div class="col-6">
                                    <FormField :labelName="$t('shipment_type')" fieldName="Shipment_Type" v-model="header" fieldClass="col-8" labelClass="col-4">
                                        <CustomSelect class="p-inputtext-sm" v-model="header.Shipment_Type" :url="this.$API_URL + 'list/lookup'" :minLength="0" :params="{ group: $LOOKUP_GROUP.SHIPMENT_TYPE}" v-if="header" :disabled="true"/>
                                    </FormField>

                                    <FormField :labelName="$t('loading')" fieldName="Loading_Destination_From_Id" v-model="header" fieldClass="col-8" labelClass="col-4">
                                        <CustomSelect class="p-inputtext-sm" v-model="header.Loading_Destination_From_Id" :url="this.$API_URL + 'list/location'" :minLength="0" :params="{ }" v-if="header" :disabled="true"/>
                                    </FormField>

                                    <FormField :labelName="$t('stuffing_date')" fieldName="Stuffing_Date" v-model="header" fieldClass="col-8" labelClass="col-4">
                                        <DatePicker dateFormat="dd/mm/yy" class="p-inputtext-sm" v-model="stuffingDate" selectionMode="range" v-if="header" :disabled="true"/>
                                    </FormField>
<!-- 
                                    <FormField :labelName="$t('charge_oa_company')" fieldName="Charge_OA_Company" v-model="header" fieldClass="col-8" labelClass="col-4">
                                        <CustomSelect class="p-inputtext-sm" v-model="header.Charge_OA_Company" :url="this.$API_URL + 'list/company_code'" :minLength="0" :params="{ }" v-if="header" :disabled="true"/>
                                    </FormField> -->
                                    
                                    <FormField :labelName="$t('trip_type')" fieldName="Trip_Type" v-model="header" fieldClass="col-8" labelClass="col-4">
                                        <CustomSelect class="p-inputtext-sm" v-model="header.Trip_Type" :url="this.$API_URL + 'list/lookup'" :minLength="0" :params="{ group: $LOOKUP_GROUP.FREIGHT_TRIP_TYPE }" v-if="header" :disabled="true"/>
                                    </FormField>

                                    <div v-if="phase2">
                                        <FormField :labelName="$t('ln_type')" fieldName="ln_type" v-model="header" fieldClass="col-8" labelClass="col-4">
                                            <InputText class="p-inputtext-sm" v-model="header.LN_Type" v-if="header"  :disabled="true"/>
                                        </FormField>

                                        <FormField :labelName="$t('incoterm_rule')" fieldName="ln_inco_rule" v-model="header" fieldClass="col-8" labelClass="col-4">
                                            <CustomSelect class="p-inputtext-sm" v-model="header.LN_Inco_Rule" :url="this.$API_URL + 'list/incoterm_rule'" :minLength="0" :params="{ }" v-if="header" :filter="true" :disabled="true"/>
                                        </FormField>
                                    </div>
                                </div>
                                <div class="col-6">
                                     <FormField :labelName="''" fieldName="Shipment_Type" v-model="header" fieldClass="col-8" labelClass="col-4">
                                        <!-- <CustomSelect class="p-inputtext-sm" v-model="header.Shipment_Type" :url="this.$API_URL + 'list/lookup'" :minLength="0" :params="{ group: $LOOKUP_GROUP.SHIPMENT_TYPE}" v-if="header" :disabled="true"/> -->
                                    </FormField>

                                    <FormField :labelName="$t('destination')" fieldName="Loading_Destination_To_Id" v-model="header" fieldClass="col-8" labelClass="col-4">
                                        <CustomSelect class="p-inputtext-sm" v-model="header.Loading_Destination_To_Id" :url="this.$API_URL + 'list/location'" :minLength="0" :params="{ }" v-if="header" :disabled="true"/>
                                    </FormField>

                                    <FormField :labelName="$t('freight_date')" fieldName="Freight_Date" v-model="header" fieldClass="col-8" labelClass="col-4" v-if="!isRelation">
                                        <DatePicker :placeholder="$t('freight_date')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="header" v-model="header.Freight_Cost_Date" :disabled="true" />
                                    </FormField>
                                    
                                    <FormField :labelName="$t('vessel')" fieldName="Vessel" v-model="header" fieldClass="col-8" labelClass="col-4">
                                        <InputText class="p-inputtext-sm" v-model="header.Vessel" v-if="header"  :disabled="true"/>
                                    </FormField>
<!-- 
                                    <FormField :labelName="$t('freight_date')" fieldName="Freight_Date" v-model="header" fieldClass="col-8" labelClass="col-4">
                                        <DatePicker :placeholder="$t('freight_date')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="header" v-model="header.Freight_Date" :disabled="true" />
                                    </FormField> -->

                                    <FormField :labelName="$t('transporter_notes')" fieldName="Transporter_Notes" v-model="header" fieldClass="col-8" labelClass="col-4">
                                        <Textarea class="p-inputtext-sm" v-model="header.Transporter_Notes" :autoResize="true" rows="3" cols="30" v-if="header" :disabled="true"/>
                                    </FormField>

                                    <FormField :labelName="$t('route_no')" fieldName="Route_No" v-model="header" fieldClass="col-8" labelClass="col-4">
                                        <InputText class="p-inputtext-sm" v-model="header.Route_No" v-if="header"  :disabled="true"/>
                                    </FormField>

                                    <FormField :labelName="$t('tender_no')" fieldName="Tender_No" v-model="header" fieldClass="col-8" labelClass="col-4">
                                        <InputText class="p-inputtext-sm" v-model="header.Tender_No" v-if="header"  :disabled="true"/>
                                    </FormField>
                                </div>
                            </div>

                            <Divider />

                            <div class="grid">
                                <div class="col-6">
                                    <FormField :labelName="$t('transporter')" fieldName="Transporter_Code" v-model="header" fieldClass="col-8" labelClass="col-4">
                                        <CustomSelect class="p-inputtext-sm" v-model="header.Transporter_Code" :url="this.$API_URL + 'list/transporter_all'" :minLength="0" :params="{ }" v-if="header && !isRelation" :disabled="true"/>
                                        <CustomSelect class="p-inputtext-sm" v-model="header.Customer_Code" :url="this.$API_URL + 'list/customer_code'" :minLength="0" :params="{ company: header.Company_Code}" v-if="header && useCustomer && isRelation" :disabled="true" />
                                        <CustomSelect class="p-inputtext-sm" v-model="header.Vendor_Code" :url="this.$API_URL + 'list/vendor'" :minLength="0" :params="{ }" v-if="header && useVendor && isRelation" :disabled="true"/>
                                    </FormField>

                                    <FormField :labelName="$t('freight_cost_suggested')" fieldName="Freight_Cost_Suggested" v-model="header" fieldClass="col-8" labelClass="col-4">
                                        <!-- <InputText name="Freight_Cost_Suggested" v-model="header.Freight_Cost_Suggested" type="text" v-if="header" :disabled="true" /> -->
                                        <InputNumber v-model="header.Freight_Cost_Suggested" mode="decimal" :optionalDecimal="true" :disabled="true" v-if="header"/>
                                    </FormField>

                                    <FormField :labelName="$t('freight_cost')" fieldName="Freight_Cost" v-model="header" fieldClass="col-8" labelClass="col-4">
                                        <!-- <InputText name="Freight_Cost" v-model="header.Freight_Cost" type="text" v-if="header" :disabled="true" /> -->
                                        <InputNumber v-model="header.Freight_Cost" mode="decimal" :optionalDecimal="true" :disabled="true" v-if="header"/>
                                    </FormField>

                                    <FormField :labelName="$t('user_num_trip')" fieldName="User_NoT" v-model="header" fieldClass="col-8" labelClass="col-4">
                                        <div class="p-inputgroup">
                                            <InputNumber name="Freight_Container" mode="decimal" :optionalDecimal="true" disabled v-model="header.User_NoT" v-if="header"/>
                                            <span class="p-inputgroup-addon" v-if="header" style="padding-left:2rem; padding-right:2rem;">{{header.Freight_Cost_UOM}}</span>
                                        </div>
                                    </FormField>

                                    <FormField :labelName="$t('freight_total_cost_user_not')" fieldName="Freight_Total_Cost_User_NoT" v-model="header" fieldClass="col-8" labelClass="col-4">
                                        <!-- <InputText name="Freight_Cost_Suggested" v-model="header.Freight_Total_Cost_User_NoT" type="text" v-if="header" :disabled="true" /> -->
                                        <InputNumber v-model="header.Freight_Total_Cost_User_NoT" mode="decimal" :optionalDecimal="true" :disabled="true" v-if="header"/>
                                    </FormField>
                                </div>
                                <div class="col-6">
                                    <FormField :labelName="$t('truck_type')" fieldName="Truck_Type_Id" v-model="header" fieldClass="col-8" labelClass="col-4">
                                        <CustomSelect class="p-inputtext-sm" v-model="header.Truck_Type_Id" :url="this.$API_URL + 'list/truck_type'" :minLength="0" :params="{ }" v-if="header" :disabled="true"/>
                                    </FormField>

                                    <FormField :labelName="$t('assign_reason')" fieldName="Assign_Reason" v-model="header" fieldClass="col-8" labelClass="col-4">
                                        <CustomSelect class="p-inputtext-sm" v-model="header.Assign_Reason" :url="this.$API_URL + 'list/lookup'" :minLength="0" :params="{ group: $LOOKUP_GROUP.ASSIGN_REASON}" v-if="header" :disabled="true"/>
                                    </FormField>

                                    <FormField :labelName="''" fieldName="Assign_Reason_Others" v-model="header" fieldClass="col-8" labelClass="col-4">
                                        <Textarea class="p-inputtext-sm" v-model="header.Assign_Reason_Others" :autoResize="true" rows="3" cols="30" v-if="header" :disabled="true"/>
                                    </FormField>
                                </div>

                                <div class="col-12">
                                    <DataTable v-if="header" :loading="!header.Details" :value="header.Details ? header.Details : null" rowGroupMode="rowspan" groupRowsBy="header.Freight_Total_Cost_User_NoT" responsiveLayout="scroll" class="p-datatable-sm editable-cells-table" :rowClass="selectedTransporter">
                                        <Column field="Item_No" :header="$t('item_no')" key="Item_No" style="width:10%">  
                                        </Column>
                                        <Column field="Charge_OA_Company" :header="$t('charge_oa_company')" key="Item_No" style="width:10%">  
                                        </Column>
                                        
                                        <Column field="sap_no" :header="$t('sap_no')" key="sap_no" style="width:10%" v-if="!oldStyle">  
                                        </Column>
                                        <Column field="SAP_Item_No" :header="$t('sap_item_no')" key="Item_No" style="width:10%">  
                                        </Column>
                                        <Column field="Material_Name" :header="$t('material_name')" key="material_name">
                                        </Column>
                                        <Column field="Qty" :header="$t('qty')" key="Qty" style="width:15%">
                                        </Column>
                                        <Column field="UOM" :header="$t('uom')" key="UOM" style="width:10%">
                                        </Column>
                                        <Column field="Freight_Master" :header="$t('freight_master')" key="Freight_Master" style="width:10%">
                                            <template #body="slotProps">
                                                {{$formatNumber(slotProps.data.Freight_Master)}}
                                            </template>
                                        </Column>
                                        <Column field="header.Freight_Total_Cost_User_NoT" :header="$t('freight_cost')" key="Freight_Cost" style="width:10%">
                                            <template #body="">
                                                {{$formatNumber(header.Freight_Cost)}}
                                            </template>
                                        </Column>
                                        <Column field="Freight_Total_Cost" :header="$t('freight_total_cost_user_not')" style="width:10%">
                                            <template #body="slotProps">
                                                {{$formatNumber(slotProps.data.Freight_Total_Cost)}}
                                            </template>
                                        </Column>
                                    </DataTable>
                                </div>

                                <div class="col-12">
                                    <DataTable v-if="header" :loading="!header" :value="header.Freight_Logs ? header.Freight_Logs : null" responsiveLayout="scroll" class="p-datatable-sm editable-cells-table" :rowClass="selectedTransporter">
                                        <Column field="ZFRCost_No" :header="$t('zfrcost_no')" key="zfrcost_no" style="width:10%">  
                                        </Column>
                                        <Column field="transporter_name" :header="$t('transporter')" key="transporter_name" style="width:10%">  
                                        </Column>
                                        <Column field="truck_type_name" :header="$t('truck_type')" key="truck_type_name" style="width:10%" v-if="!oldStyle">  
                                        </Column>
                                        <Column field="Per_UOM" :header="$t('uom')" key="UOM" style="width:10%">  
                                        </Column>
                                        <Column field="Truck_Type_Capacity" :header="$t('capacity')" key="Truck_Type_Capacity" style="width:10%">  
                                            <template #body="slotProps">
                                                {{$formatNumber(slotProps.data.Truck_Type_Capacity)}}
                                            </template>
                                        </Column>
                                        <Column field="Freight_Master" :header="$t('freight_master')" key="Freight_Master">
                                        </Column>
                                        <Column field="Freight_KG_Capacity" :header="$t('freight_kg_based')" key="Freight_KG_Based" style="width:15%">
                                            <template #body="slotProps">
                                                {{$formatNumber(slotProps.data.Freight_KG_Capacity)}}
                                            </template>
                                        </Column>
                                        <Column field="Freight_Cost" :header="$t('freight_cost')" key="Freight_Cost" style="width:10%">
                                            <template #body="slotProps">
                                                {{$formatNumber(slotProps.data.Freight_Cost)}}
                                            </template>
                                        </Column>
                                        <Column field="System_NoT" :header="$t('system_num_trip')" key="System_NoT" style="width:10%">
                                        </Column>
                                        <Column field="Freight_Cost_Total" :header="$t('freight_total_cost')" key="Freight_Total_Cost" style="width:10%">
                                             <template #body="slotProps">
                                                {{$formatNumber(slotProps.data.Freight_Cost_Total)}}
                                            </template>
                                        </Column>
                                        <Column field="User_NoT" :header="$t('user_num_trip')" key="User_NoT" style="width:10%">
                                        </Column>
                                        <Column field="Freight_Total_Cost_User_NoT" :header="$t('freight_total_cost_user_not')" key="Freight_Total_Cost_User_NoT" style="width:10%">
                                            <template #body="slotProps">
                                                {{$formatNumber(slotProps.data.Freight_Total_Cost_User_NoT)}}
                                            </template>
                                        </Column>
                                        <Column field="Freight_KG_Delivery" :header="$t('freight_kg')" key="Freight_KG" style="width:10%">
                                            <template #body="slotProps">
                                                {{$formatNumber(slotProps.data.Freight_KG_Delivery)}}
                                            </template>
                                        </Column>
                                        <Column field="Freight_Different_Per_UOM" :header="$t('freight_different_per_uom')" key="Freight_Different_Per_UOM" style="width:10%">
                                            <template #body="slotProps">
                                                {{$formatNumber(slotProps.data.Freight_Different_Per_UOM)}}
                                            </template>
                                        </Column>
                                        <Column field="Freight_Different_Percentage" :header="$t('freight_different_percentage')" key="Freight_Different_Percentage" style="width:10%">
                                            <template #body="slotProps">
                                                {{$formatNumber(slotProps.data.Freight_Different_Percentage)}}
                                            </template>
                                        </Column>
                                        <Column field="Freight_Total_Different" :header="$t('freight_total_different')" key="Freight_Total_Different" style="width:10%">
                                             <template #body="slotProps">
                                                {{$formatNumber(slotProps.data.Freight_Total_Different)}}
                                            </template>
                                        </Column>

                                        <!-- <th style="min-width:300px; text-align:left">@DisplayNames.TRANSPORTER</th>
                                        <th style="min-width:200px">@DisplayNames.TRUCK_TYPE</th>
                                        <th style="width:50px">@DisplayNames.UOM</th>
                                        <th style="min-width:100px">@DisplayNames.TRUCK_CAPACITY</th>
                                        <th style="min-width:100px">@DisplayNames.FREIGHT_MASTER</th>
                                        <th style="min-width:100px">@DisplayNames.FREIGHT_KG_BASED</th>
                                        <th style="min-width:100px">@DisplayNames.FREIGHT_COST</th>
                                        <th style="min-width:100px">@DisplayNames.SYSTEM_NOT</th>
                                        <th style="min-width:100px">@DisplayNames.FREIGHT_TOTAL_COST</th>
                                        <th style="min-width:100px">@DisplayNames.USER_NOT</th>
                                        <th style="min-width:100px">@DisplayNames.FREIGHT_TOTAL_COST_USER</th>
                                        <th style="min-width:100px">@DisplayNames.FREIGHT_KG</th>
                                        <th style="min-width:100px">@DisplayNames.FREIGHT_DIFFERENT_PER_UOM</th>
                                        <th style="min-width:100px">@DisplayNames.FREIGHT_DIFFERENT_PERCENTAGE</th>
                                        <th style="min-width:100px">@DisplayNames.FREIGHT_TOTAL_DIFFERENT</th> -->
                                    </DataTable>
                                </div>

                            </div>
                        </div>
                        
                    </TabPanel>
                </TabView>

                
            </template>
        </Card>
    </form>
</template>


<script>
    import ViewOrder from './_ViewOrder.vue'

    export default {
        name: "Editor",
        components:{
            "ViewOrder": ViewOrder
        },
        data() {
            return {
                indexName: "OrderIndex",
                url: this.$API_URL + "order/",
                header: null,
                detail: null,
                mode: "",
                id: 0,
                isCreate: this.mode == this.$FORM_MODE_CREATE,
                isSyncSAP: false,
                oldStyle: false,
                orderType:null,
                viewTransporter: false, //untuk approval
                sapOrders: [],
                activeIndex: 0,
                phase2: false,
            }
        },
        methods: {
            getData() {
                var self = this;
                this.$axios.get(this.url + this.id + "/" + this.mode)
                    .then((response) => {
                        if(response.data.success){
                            self.header = response.data.data.header;
                            self.oldStyle = self.header.Company_Id != null && self.header.Company_Id != 0;

                            self.phase2 = self.header.phase2;

                            if(!self.oldStyle){
                                self.sapOrders = self.header.SAP_Orders;
                            }

                            self.orderType = self.header.Order_Type;

                            if(self.viewTransporter){
                                var add = self.oldStyle ? 1 : self.sapOrders.length;
                                self.$nextTick(() => {
                                    self.activeIndex = add;
                                });
                            }

                            // self.useCustomer = self.header.Order_Type.Use_Customer;
                            // self.usePurchaseOrg = self.header.Order_Type.Use_POrg;
                            // self.useSalesOrg = self.header.Order_Type.Use_SOrg;
                            // self.useVendor = self.header.Order_Type.Use_Vendor;
                            // self.useDistribution = self.header.Order_Type.Use_Distribution;
                            // self.isSyncSAP = self.header.Type == self.$ORDER_CREATE_TYPE.SYNC_SAP;
                        }
                        else{
                            //console.log("error");
                        }
                        
                    })
                    .catch(function (error) {
                        alert(error);
                    });
            },
            saveData() {
                this.$emit('block-ui');
                var self = this;
                this.$axios.post(this.url, this.header)
                    .then((response) => {
                        if (response.data.success) {
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: response.data.message, life: 120000} } );
                        }
                        else {
                            self.showError('Error Saving Data', response.data.message);
                        }
                    })
                    .catch(function (error) {
                        self.showError('Error Saving Data', error);
                    });
            },
            showError(summary, message) {
                this.$emit('unblock-ui');
                this.$toast.add({ severity: 'error', summary: summary, detail: message, life: 120000});
            },
            backToIndex() {
                this.$router.push({ path: "/Order/Index" });
            },
            toggle(event) {
                this.$refs.op.toggle(event);
            },
            confirm(event) {
                this.$confirm.require({
                    target: event.currentTarget,
                    message: 'Are you sure?',
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        this.saveData();
                    },
                    reject: () => {
                        //callback to execute when user rejects the action
                    }
                });
            },
            selectedTransporter(data){
                // console.log("TRUCK TYPE: " + this.header.Truck_Type_Id + ", " + data.Truck_Type_Id);
                // console.log("TRANSPORTER: " + this.header.Transporter_Code + ", " + data.Transporter_Code);
                // console.log("FREIGHT VALUE: " + this.header.Freight_Cost_Value + ", " + data.Freight_Value);
                // console.log("UOM: " + this.header.Freight_Cost_UOM + ", " + data.Per_UOM);

                if(this.header.Truck_Type_Id == data.Truck_Type_Id 
                    && this.header.Transporter_Code == data.Transporter_Code
                    && (data.Freight_Value ? data.Freight_Value == this.header.Freight_Cost_Value : false == this.header.Freight_Cost_Value)
                    && data.Per_UOM == this.header.Freight_Cost_UOM
                ){
                    return "selected-transporter";
                }
                else return "";
            }
        },
        created() {
            this.mode = this.$route.query.mode;
            this.id = this.$route.query.id ?? 0;

            this.getData();

            if(this.$route.query.view_type == "APPR"){
                this.viewTransporter = true;
            }
        },
        computed:{
            stuffingDate(){
                var date = []

                if(this.header){
                    if(this.header.Stuffing_Date_From){
                        date.push(new Date(this.header.Stuffing_Date_From));
                        date.push(new Date(this.header.Stuffing_Date_To));
                    }
                }

                return date;
            },
            isRelation(){ 
                return this.header ? this.header.is_relation : false;
            },
            useVendor(){
                return this.orderType ? this.orderType.Use_Vendor : false;
            },
            useCustomer(){
                return this.orderType ? this.orderType.Use_Customer : false;
            }

        }
    }
</script>